import { SessionStorage } from '@/utils/storage';

const PREFILL_EMAIL_STORAGE_KEY = 'prefilled_email';

export const saveEmail = {
  mounted(form) {
    form.addEventListener('submit', onSubmit);

    function onSubmit(e) {
      const email = e.currentTarget.email.value;
      SessionStorage.set(PREFILL_EMAIL_STORAGE_KEY, email);
    }
  },
};

export const prefillEmail = {
  mounted(el) {
    const prefilledEmail = SessionStorage.get(PREFILL_EMAIL_STORAGE_KEY);
    if (!prefilledEmail) return;

    el.scrollIntoView();

    const initialEmailField = findEmailField();
    if (initialEmailField) {
      initialEmailField.value = prefilledEmail;
    } else {
      const observer = new MutationObserver(() => {
        const renderedEmailField = findEmailField();
        if (renderedEmailField) {
          setTimeout(() => {
            renderedEmailField.value = prefilledEmail;
            SessionStorage.remove(PREFILL_EMAIL_STORAGE_KEY);
            observer.disconnect();
          }, 500);
        }
      });

      observer.observe(el, {
        childList: true,
        subtree: true,
      });
    }

    function findEmailField() {
      return el.querySelector('form [type="email"]');
    }
  },
};
